import { fromJS } from 'immutable';

export default {
    setEnv: (state, environment) => {
        if (!environment) environment = 'empty';
        return state.set('active', environment);
    },
    setEnvsConfig: (state, environments) => {
        const envs = fromJS(environments);
        return state.setIn(
            ['list'],
            state.get('list').map((envConfig, envName) => {
                return envs.getIn([envName], null);
            })
        );
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Environments/core.js